import { formatDate } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItemSettingBookingDate } from '../editor-booking-item-setting/editor-booking-item-setting-booking-date.model';


@Component({
    selector: 'eas-editor-booking-item-setting-summary-booking-date',
    templateUrl: './editor-booking-item-setting-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingSummaryBookingDateComponent implements OnChanges, OnInit {
  @Input() itemSetting: EditorBookingItemSettingBookingDate;
  @Input() first: boolean;
  @Input() last: boolean;

  summary: string;

  constructor(@Inject(LOCALE_ID) private locale: string) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.summary = this.getSummary();
    }
  }

  getSummary(): string {
    const formattedStart = this.itemSetting.start === null ? null : formatDate(this.itemSetting.start.toDate(), 'short', this.locale);
    const formattedDateStart = this.itemSetting.start === null ? null : formatDate(this.itemSetting.start.toDate(), 'shortDate', this.locale);
    const formattedTimeStart = this.itemSetting.start === null ? null : formatDate(this.itemSetting.start.toDate(), 'shortTime', this.locale);
    const formattedEnd = this.itemSetting.end === null ? null : formatDate(this.itemSetting.end.toDate(), 'short', this.locale);
    const formattedDateEnd = this.itemSetting.end === null ? null : formatDate(this.itemSetting.end.toDate(), 'shortDate', this.locale);
    const formattedTimeEnd = this.itemSetting.end === null ? null : formatDate(this.itemSetting.end.toDate(), 'shortTime', this.locale);

    let summary: string;
    if (this.itemSetting.start !== null && this.itemSetting.end !== null) {
      summary = (formattedDateStart === formattedDateEnd)
        ? $localize `taking place on ${formattedDateStart}, from ${formattedTimeStart} to ${formattedTimeEnd}`
        : $localize `taking place from ${formattedStart} to ${formattedEnd}`;
    } else if (this.itemSetting.start !== null) {
      summary = $localize `taking place from ${formattedStart}`;
    } else if (this.itemSetting.end) {
      summary = $localize `taking place until ${formattedEnd}`;
    }

    if (summary === undefined) {
      return '';
    }

    if (this.itemSetting.timezone !== null) {
      summary = `${summary} ${this.itemSetting.timezone}`;
    }

    summary = this.first ? summary.charAt(0).toUpperCase() + summary.slice(1) : summary;
    if (!this.last) {
      summary = `${summary}, `;
    }

    return summary;
  }
}
